<template>
  <div>
    <div class="container">
      <!-- <pre>{{fields}}</pre> -->
      <h2>{{ page.Title }}</h2>
      <div v-if="page.Content" v-html="page.Content"></div>
      <div class="row">
        <div class="col-md-6">
          <!-- Jobsituation -->
          <DoEmployment
            v-model="page.Questions[0].Value"
            :value="page.Questions[0].Value"
            :id="page.Questions[0].QID"
            :config="page.Questions[0].Config"
            :options="page.Questions[0].Options"
            @getNewData="makeArray"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    methods: {
      makeArray() {
        sessionStorage.clear();
        sessionStorage.setItem('employment', this.page.Questions[0].Value);

        // Get step by webservice and store them in page. Afterward doNewData
        this.$store.dispatch('doNewData', this.page.Questions[0].Value);
      },
      makeLevelArray() {
        sessionStorage.clear();
        sessionStorage.setItem('employment', this.page.Questions[0].Value);
        this.$store.dispatch('doNewData', this.page.Questions[0].Value);
      },
    },
    beforeCreate() {
      var routePath = this.$route.path.split('/');
      this.$store.state.preSelectedEmployment = routePath[routePath.length - 1];
    },
  };
</script>
<style lang="scss" scoped></style>
